import React from 'react';
export function WhatYouGet() {
  return <section className="w-full bg-[#0a0a0a] py-16 px-4 pt-[10px] pb-[10px]" data-id="element-429">
      <div className="max-w-5xl mx-auto" data-id="element-430">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-12" data-id="element-431">
          Lo que <span className="text-[#00C853]" data-id="element-432">recibís</span>
        </h2>

        <div className="max-w-2xl mx-auto mb-12" data-id="element-433">
          <div className="bg-black border border-[#00C853]/30 rounded-2xl p-6" data-id="element-434">
            <h3 className="text-[#00C853] text-xl font-black mb-2" data-id="element-435">
              🇮🇹 A1 → C1/C2 — 6 TOMOS
            </h3>
            <p className="text-gray-400 text-sm mb-5" data-id="element-436">
              Para docentes de Italiano de secundaria e institutos
            </p>
            <div className="space-y-4" data-id="element-437">
              <div className="flex items-center gap-3 text-white" data-id="element-438">
                <span className="text-xl" data-id="element-439">📘</span>
                <div className="flex-1" data-id="element-440">
                  <span className="font-bold" data-id="element-441">
                    Tomo 1 — Nivel A1: Base Pronta
                  </span>
                  <span className="text-gray-300" data-id="element-442">
                    {' '}
                    Alfabeto, saludos, números, colores, familia, artículos,
                    Presente Indicativo y ESSERE & AVERE.
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-443">
                <span className="text-xl" data-id="element-444">📗</span>
                <div className="flex-1" data-id="element-445">
                  <span className="font-bold" data-id="element-446">
                    Tomo 2 — Nivel A2: Connessione
                  </span>
                  <span className="text-gray-300" data-id="element-447">
                    {' '}
                    Passato Prossimo, Imperfetto, preposizioni articuladas,
                    pronomi diretti, ciudad, transportes, salud y hobbies.
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-448">
                <span className="text-xl" data-id="element-449">📙</span>
                <div className="flex-1" data-id="element-450">
                  <span className="font-bold" data-id="element-451">Tomo 3 — Nivel B1: Sviluppo</span>
                  <span className="text-gray-300" data-id="element-452">
                    {' '}
                    Futuro, Condizionale, pronomi combinati, SI impersonale,
                    Periodo Ipotetico Tipo 1 y 2, viajes, trabajo y tecnología.
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-453">
                <span className="text-xl" data-id="element-454">📕</span>
                <div className="flex-1" data-id="element-455">
                  <span className="font-bold" data-id="element-456">Tomo 4 — Nivel B2: Opinione</span>
                  <span className="text-gray-300" data-id="element-457">
                    {' '}
                    Congiuntivo (todos los tiempos), Concordanza, Periodo
                    Ipotetico Tipo 3, Passiva, Discorso Indiretto, sociedad y
                    debate.
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-458">
                <span className="text-xl" data-id="element-459">📓</span>
                <div className="flex-1" data-id="element-460">
                  <span className="font-bold" data-id="element-461">
                    Tomo 5 — Nivel C1/C2: Maestria
                  </span>
                  <span className="text-gray-300" data-id="element-462">
                    {' '}
                    Registro formal y académico, expresiones idiomáticas,
                    sintaxis compleja, análisis literario, textos periodísticos
                    y certificaciones.
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-463">
                <span className="text-xl" data-id="element-464">📔</span>
                <div className="flex-1" data-id="element-465">
                  <span className="font-bold" data-id="element-466">
                    Tomo 6 — Valutazione & Kit Completo
                  </span>
                  <span className="text-gray-300" data-id="element-467">
                    {' '}
                    24 verifiche completas (4 por nivel), Test de Placement,
                    fichas de seguimiento, planificador anual, Kit de
                    Emergencia, diplomas y Solucionario Maestro.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* What each tome includes */}
        <div className="bg-[#00C853]/5 border border-[#00C853]/30 rounded-2xl p-8 text-center" data-id="element-468">
          <h3 className="text-[#00C853] text-xl font-black mb-6" data-id="element-469">
            Cada tomo incluye:
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-3xl mx-auto" data-id="element-470">
            <div className="flex items-start gap-2 text-left" data-id="element-471">
              <span className="text-[#00C853] font-bold flex-shrink-0" data-id="element-472">✅</span>
              <span className="text-white text-sm" data-id="element-473">
                Planificación anual completa lista para entregar a jefatura o
                dirección del instituto
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-474">
              <span className="text-[#00C853] font-bold flex-shrink-0" data-id="element-475">✅</span>
              <span className="text-white text-sm" data-id="element-476">
                14 Unidades Didácticas con desarrollo teórico completo y
                ejemplos reales
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-477">
              <span className="text-[#00C853] font-bold flex-shrink-0" data-id="element-478">✅</span>
              <span className="text-white text-sm" data-id="element-479">
                Secuencias didácticas con estructura explicación–práctica
                escrita–práctica oral–producción
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-480">
              <span className="text-[#00C853] font-bold flex-shrink-0" data-id="element-481">✅</span>
              <span className="text-white text-sm" data-id="element-482">
                Actividades fotocopiables (Ejercicios 1, 2 y 3) listas para
                imprimir o compartir
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-483">
              <span className="text-[#00C853] font-bold flex-shrink-0" data-id="element-484">✅</span>
              <span className="text-white text-sm" data-id="element-485">
                4 Verifiche (exámenes parciales) + 1 Verifica Final por nivel
                con criterios de corrección
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-486">
              <span className="text-[#00C853] font-bold flex-shrink-0" data-id="element-487">✅</span>
              <span className="text-white text-sm font-bold" data-id="element-488">
                SOLUCIONARIO COMPLETO con todas las respuestas y justificaciones
                gramaticales
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-489">
              <span className="text-[#00C853] font-bold flex-shrink-0" data-id="element-490">✅</span>
              <span className="text-white text-sm" data-id="element-491">
                Diploma de completamiento imprimible para cada nivel
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-492">
              <span className="text-[#00C853] font-bold flex-shrink-0" data-id="element-493">✅</span>
              <span className="text-white text-sm" data-id="element-494">
                Sección de errores de interferencia español-italiano integrada
                en todos los niveles
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-495">
              <span className="text-[#00C853] font-bold flex-shrink-0" data-id="element-496">✅</span>
              <span className="text-white text-sm" data-id="element-497">
                Conexión cultural Italia-Argentina en cada unidad
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-498">
              <span className="text-[#00C853] font-bold flex-shrink-0" data-id="element-499">✅</span>
              <span className="text-white text-sm" data-id="element-500">
                100% alineado al Marco Común Europeo de Referencia (MCER)
                vigente
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-501">
              <span className="text-[#00C853] font-bold flex-shrink-0" data-id="element-502">✅</span>
              <span className="text-white text-sm" data-id="element-503">
                Italiano Estándar moderno (no anticuado ni demasiado formal)
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}